module.exports = __webpack_public_path__ + "21cddbeff39a77a7205bc68f05e5e942.svg";